<div class="timeline-container">
  <div class="breadcrumbs">
    @for (breadcrumb of breadcrumbList; track breadcrumb; let lastItem = $last) {
      <span class="crumb"
      (click)="!lastItem ? navigateToTaskflow(breadcrumb.id!):null">{{ breadcrumb.title }}</span>
      @if (!lastItem) {
        <span>></span>
      }
    }
  </div>
  <div class="timeline">
    @for (step of steps; track step) {
      <div class="timeline-step" [ngClass]="{ locked: step.locked, active: step.active }">
        <div class="dot" [ngClass]="{ triggers: stepHasActiveTriggers(step.number) }"></div>
        <div class="task-container">
          @for (subTaskflow of subTasksflowsInStep(step.number); track subTaskflow) {
            <div>
              @if (subTaskflow.status === taskflowStatusTypeEnum.Completed) {
                <span class="status-icon fas fa-check"></span>
              }
              <div class="sub-taskflow"
                [ngClass]="{ closed: subTaskflow.status === taskflowStatusTypeEnum.Completed }"
                (click)="navigateToTaskflow(subTaskflow.id!)">
                <span class="taskflow-title">{{ subTaskflow.title }}</span>
                <span class="stripe"></span>
              </div>
            </div>
          }
          @for (task of tasksInStep(step.number); track task) {
            <div>
              @if (task.completed) {
                <span class="status-icon fas fa-check"></span>
              }
              <div class="task-action"
                [ngClass]="{ closed: task.completed, active: task === activeTaskAction }"
                [style.backgroundColor]="task.taskArea ? task.taskArea.color : ''"
                (mousedown)="activeTaskActionChange.emit(task)">
                <span class="task-icon">{{ (task.taskTemplate ? task.taskTemplate.title : 'enum.task-template-type.' + taskType(task.type) | translate) | slice:0:1 }}</span>
                <span class="task-assignee">{{ task.assignedToUserId | user: 'initials' }}</span>
              </div>
            </div>
          }
          @if (tentativeTaskAction && tentativeTaskAction.step === step.number) {
            <div class="task-action">
              <span class="task-icon"></span><span class="task-assignee"></span>
            </div>
          }
          <div class="add-task" (click)="createNewTaskActionOnStep(step.number)"></div>
        </div>
      </div>
    }
    <div [class.no-action]="!userIsOwner" class="show-last" editable-content *editableData="let edit from taskflow.deadline" (valueChanged)="updateDeadline($event)" (onEditStart)="testDateConflicts($event)">
      <display-content>
        <div class="timeline-step deadline" [ngClass]="{ 'has-value': taskflow.deadline }">
          <div class="dot"></div>
          @if (taskflow.deadline) {
            {{ 'taskflow.deadline' | translate }}<br />
            {{ taskflow.deadline | customDate: 'shortDate' }}
          }
          @if (!taskflow.deadline) {
            <span class="default-text">{{ 'taskflow.no-deadline' | translate }}</span>
            <span class="hover-text">{{ 'taskflow.change-deadline' | translate }}</span>
          }
        </div>
      </display-content>
      <edit-content>
        <div class="font-weight-bold">
          <icon type="calendar-alt" />
          {{ 'taskflow.choose-deadline' | translate }}
        </div>
        <date-picker [minDate]="today" [markedDates]="markedDates" [suggestedMinDate]="suggestedDate" [(model)]="edit.value" (modelChange)="testDateConflicts($event)" />

        @if (dateConflicts.length > 0) {
          <div>
            <div class="status-color-negative">{{ 'taskflow.deadline-conflicts' | translate }}</div>
            @for (conflict of dateConflicts; track conflict) {
              <div class="deadline-conflict">
                @if (conflict.taskflow) {
                  <a (click)="navigateToTaskflow(conflict.taskflow.id!)">{{ conflict.taskflow.title }}</a>
                }
                @if (conflict.taskAction) {
                  <a (click)="navigateToTaskAction(conflict.taskAction)">{{ 'enum.task-template-type.' + taskType(conflict.taskAction.type) | translate }}</a>
                }
                <span>{{ conflict.date | customDate: 'shortDate' }}</span>
              </div>
            }
          </div>
        }
      </edit-content>
    </div>
  </div>
</div>
